/**
 * Sort UK sizes on the variant picker numerically (UK3.5, UK4, UK4.5, ...).
 *
 * Combined Listing parents merge their children's Size option values in the
 * order the children were linked, so late-added small sizes appear after
 * larger ones on the storefront. The Shopify admin exposes reorder for the
 * Color option on the parent, but not Size — so we sort in the DOM.
 *
 * Detection is content-based (values matching /uk\d/i), not name-based, so
 * it works across storefront locales and any variant-picker layout.
 */
(function () {
  'use strict';

  if (window.__akoSizeUkSortInit) return;
  window.__akoSizeUkSortInit = true;

  var CONTAINER_SELECTORS = [
    'variant-picker .popover-listbox',
    'variant-picker .variant-picker__option-values'
  ];
  // Where a new variant-picker might appear late (quick-buy modals, drawer).
  var LATE_HOST_SELECTOR = 'variant-picker, product-card, cart-notification-drawer, .quick-buy-drawer';
  var UK_PATTERN = /uk\s*(\d+(?:\.\d+)?)/i;

  function extractUkNumber(text) {
    if (!text) return null;
    var m = text.match(UK_PATTERN);
    return m ? parseFloat(m[1]) : null;
  }

  function sortContainer(container) {
    var nodes = container.childNodes;
    if (nodes.length < 2) return;

    // Group by walking ALL child nodes (elements + whitespace text) and
    // closing a group whenever we hit a visible <label>/<a>. Text nodes
    // ride with the preceding element so whitespace layout is preserved.
    var groups = [];
    var buffer = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      buffer.push(node);
      if (node.nodeType === 1) {
        var tag = node.tagName;
        if (tag === 'LABEL' || tag === 'A') {
          groups.push({ nodes: buffer, key: extractUkNumber(node.textContent) });
          buffer = [];
        }
      }
    }
    // Trailing whitespace with no closing label — leave in place at end.
    var trailing = buffer;

    var keyed = 0;
    for (var j = 0; j < groups.length; j++) if (groups[j].key !== null) keyed++;
    if (keyed < 2) return;

    var alreadySorted = true;
    for (var k = 1; k < groups.length; k++) {
      var a = groups[k - 1].key;
      var b = groups[k].key;
      if (a !== null && b !== null && a > b) { alreadySorted = false; break; }
    }
    if (alreadySorted) return;

    var sorted = groups.slice().sort(function (x, y) {
      if (x.key === null && y.key === null) return 0;
      if (x.key === null) return 1;
      if (y.key === null) return -1;
      return x.key - y.key;
    });

    var frag = document.createDocumentFragment();
    for (var s = 0; s < sorted.length; s++) {
      var gn = sorted[s].nodes;
      for (var n = 0; n < gn.length; n++) frag.appendChild(gn[n]);
    }
    for (var t = 0; t < trailing.length; t++) frag.appendChild(trailing[t]);
    container.replaceChildren(frag);
  }

  function sortAll(root) {
    var scope = root || document;
    CONTAINER_SELECTORS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(sortContainer);
    });
  }

  function schedule() { setTimeout(function () { sortAll(); }, 0); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // product:rerender is dispatched on the product form without bubbles:true
  // (theme.js). Capture-phase listeners still fire for non-bubbling events,
  // so this reaches us from any descendant form.
  document.addEventListener('product:rerender', schedule, true);

  function startObserver() {
    // Skip pages that will never render or receive a variant-picker.
    if (!document.querySelector(LATE_HOST_SELECTOR)) return;

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            node.tagName === 'VARIANT-PICKER' ||
            (node.querySelector && node.querySelector('variant-picker'))
          ) {
            schedule();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
